import 'dropzone-vue/dist/dropzone-vue.common.css'
import DropZone from 'dropzone-vue'

export default function (app: any) {
  return app.use(DropZone)
}
